import React from "react";

const About = () => {
  return (
    <div className="container mx-auto mt-16 mb-10 p-6">
      <div className="flex justify-center">
        <h1 className="text-3xl font-display font-semibold text-center">About Goyal&Co.</h1>
      </div>
      <div className="mt-6 text-xl ml-5 mr-5 md:ml-20 md:mr-20 md:px-28 px-10">
        <p className="text-justify">
          Goyal & Co. was founded in year 1970 in Ahmedabad. It is one of the
          leading real estate developer in Western & Southern India, both in
          terms of residential and commercial. Choicest locations, perfect
          planning and immaculate implementation have ensured value for it's
          customers. Known for delivering beyond the call of duty, Goyal & Co.
          has systematically built on its credibility and goodwill with every
          project it has launched over the years. It has a legacy of more than
          four decades and till now has delivered more than 200 projects. The
          company is on upwards growth trajectory and is one of the fastest
          growing real estate developers in India.
        </p>
        <br />
      </div>
    </div>
  );
};

export default About;
